import { translateTemplateWay } from '@/data/i18n/json/templateMap'
import store from '@/store'
import { genCCWSideHoleSlot } from '@/util/LayoutFuncs'
import { getOtherSideMachineTargets } from '@/util/commonFuncs'
import { PtToPx, getDeviceXDPI, mmToPx } from '@/util/exportFuncs'

import { calculateSlantedRectanglePath } from '../commonFun'
import { dealElementWH } from './pdf-draw'

let CONFIG = {}
let NC_SETTING = {}
const DPI = getDeviceXDPI()
// 映射封边信息合位置关系
const dirDataMap = {
  '←': '左',
  '↓': '下',
  '→': '右',
  '↑': '上',
}
// 真正要展示的位置和数据中的开门方向正好相反
const openDirMap = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top',
}
const OPENMAPTEXT = {
  left: '左',
  right: '右',
  top: '上',
  bottom: '下',
}
const TRIANGLE_WIDTH = 10
const TRIANGLE_HEIGHT = 7
// 初始化一些数据
export function initDrawData(config, nc) {
  CONFIG = config
  NC_SETTING = nc
}

// 绘制单个板件的孔槽图
export function drawPartHoleSlot(
  canvas,
  part,
  rectL,
  rectT,
  info,
  other,
  jx_checked
) {
  const { left, top, holeF, holeZ, defaultScale, uniqueID, partEdge } = info
  const { oRect: rect } = part
  // 获取子级
  const auxiliary = other.tempData.filter(
    (item) =>
      item.data &&
      item.data.uniqueID == uniqueID &&
      item.type == 'holeSlotPicture-size'
  )
  // 获取板件是否需要逆时针旋转
  let isRotatePlank
  const typographyKlass = other.tempData.find((it) => it.type === 'Typography')

  if (typographyKlass) {
    isRotatePlank = typographyKlass.data.plankRotate
  }
  // 默认的缩放大小(我一时竟不知道该怎么给这玩意赋值了，就是一个默认值了)
  let pw = mmToPx(info.mWidth, DPI) / rect.width
  let ph = mmToPx(info.mHeight, DPI) / rect.height
  const slotHoleDefaultScale = Math.min(pw, ph) * defaultScale
  // 起始点
  const cutLeft = (left - rectL) * CONFIG.scale
  const cutTop = (top - rectT) * CONFIG.scale
  // 需要显示的孔槽
  let allHole = [],
    allSlot = [],
    allCurveSlot = [],
    allLineSlot = []
  // 标签反色后的填充色及背景色
  // 填充色始终透明，取下层颜色，否则会出现覆盖问题
  let fill = !other?.gen_part_color_revert ? '#fff' : '#000'
  let stroke = !other?.gen_part_color_revert ? '#00' : '#fff'
  if (holeZ) {
    allHole = [...allHole, ...part.holes.filter((item) => item.side == 1)]
    allSlot = [...allSlot, ...part.slots.filter((item) => item.side == 1)]
    allCurveSlot = [
      ...allCurveSlot,
      ...(part.curveHoles
        ? part.curveHoles.filter(
            (item) => item.side == 1 && item.disType == 'CCCurveSlot'
          )
        : []),
    ]
    allLineSlot = [
      ...allLineSlot,
      ...(part.lineSlots
        ? part.lineSlots.filter((item) => item.side == 1)
        : []),
    ]
  }
  if (holeF) {
    allHole = [...allHole, ...part.holes.filter((item) => item.side == -1)]
    allSlot = [...allSlot, ...part.slots.filter((item) => item.side == -1)]
    allCurveSlot = [
      ...allCurveSlot,
      ...(part.curveHoles
        ? part.curveHoles.filter(
            (item) => item.side == -1 && item.disType == 'CCCurveSlot'
          )
        : []),
    ]
    allLineSlot = [
      ...allLineSlot,
      ...(part.lineSlots
        ? part.lineSlots.filter((item) => item.side == -1)
        : []),
    ]
  }
  let mainShape
  let shapes = []
  if (part.path) {
    let curveHoles = []
    if (part.curveHoles) {
      if (jx_checked) {
        part.curveHoles.forEach((item) => {
          item.path.forEach((point) => {
            if (NC_SETTING.xyReverse) {
              point.y = rect.height - point.y
            } else {
              point.x = rect.width - point.x
            }
          })
        })
      }
      curveHoles = part.curveHoles
        .filter((it) => it.deep >= part.thick)
        .map((it) => it.path)
    }
    let millInfos = []
    if (part.millInfo) {
      if (jx_checked) {
        part.millInfo.forEach((item) => {
          item.shape.forEach((point) => {
            if (NC_SETTING.xyReverse) {
              point.y = rect.height - point.y
            } else {
              point.x = rect.width - point.x
            }
          })
        })
      }
      millInfos = part.millInfo
        .filter((it) => it.depth >= part.thick)
        .map((it) => it.shape)
    }
    const resPath = [...part.path, ...curveHoles, ...millInfos]
    resPath.forEach((it, idx) => {
      const pointArr = it.map((p) => {
        return {
          x: p.x * slotHoleDefaultScale * CONFIG.scale,
          y: p.y * slotHoleDefaultScale * CONFIG.scale,
        }
      })
      const shape = new fabric.Polygon(pointArr, {
        stroke,
        fill,
        strokeWidth: 1,
        selectable: false,
      })
      shapes.push(shape)
      if (idx === 0) mainShape = shape
    })
  } else {
    mainShape = new fabric.Rect({
      selectable: false,
      stroke,
      strokeWidth: 1.5,
      fill,
      width: rect.width * slotHoleDefaultScale * CONFIG.scale,
      height: rect.height * slotHoleDefaultScale * CONFIG.scale,
    })
  }
  // 绘制文本
  let textArr = []
  if (auxiliary[0].data.isShow) {
    auxiliary.forEach((klass) => {
      const { positionName, fontSize } = klass.data
      const text = parseFloat(Number(rect[positionName]).toFixed(2)) + ''
      const { offsetWidth, offsetHeight } = dealElementWH(text, fontSize)
      let left, top
      if (positionName == 'width') {
        top =
          (jx_checked && NC_SETTING.xyReverse) || !NC_SETTING.xyReverse
            ? mainShape.height
            : -32
        left = mainShape.width / 2
      } else {
        top = mainShape.height / 2
        left = !(jx_checked && !NC_SETTING.xyReverse) ? mainShape.width : -32
      }
      // 做旋转的位置调整
      if (NC_SETTING.xyReverse && !isRotatePlank) {
        top += mmToPx(offsetWidth / 2, DPI)
        left -= mmToPx(offsetWidth, DPI) - mmToPx(offsetHeight, DPI) - 3
      }
      if (!NC_SETTING.xyReverse && isRotatePlank) {
        top += mmToPx(offsetHeight / 2, DPI)
        left -= mmToPx(offsetWidth / 3, DPI)
      }
      const res = new fabric.Text(text, {
        fontSize: klass.data.fontSize * CONFIG.scale,
        top,
        left,
        selectable: false,
        fontWeight: klass.data.fontWeight,
        lineHeight: klass.data.lineHeight,
        splitByGrapheme: klass.data.splitByGrapheme
          ? klass.data.splitByGrapheme
          : false, // 自动换行
        textAlign: klass.data.textAlign ? klass.data.textAlign : 'left',
        fontFamily: klass.data.fontFamily ?? '微软雅黑',
        fill: stroke,
      })
      if (NC_SETTING.xyReverse || isRotatePlank) res.rotate(90)
      if (NC_SETTING.xyReverse && isRotatePlank) res.rotate(180)
      textArr.push(res)
    })
  }
  // 绘制孔
  let drawHoles = []
  allHole.forEach((item) => {
    const { diameter, ocenter: center } = item
    const x = !(jx_checked && !NC_SETTING.xyReverse)
      ? center.x * slotHoleDefaultScale
      : (rect.width - center.x) * slotHoleDefaultScale
    const y = !(jx_checked && NC_SETTING.xyReverse)
      ? center.y * slotHoleDefaultScale
      : (rect.height - center.y) * slotHoleDefaultScale
    const left = x * CONFIG.scale
    const top = y * CONFIG.scale
    const radius = (diameter / 2) * slotHoleDefaultScale * CONFIG.scale
    const circle = new fabric.Circle({
      radius, //圆形半径
      fill, //填充的颜色
      stroke, // 边框颜色
      strokeWidth: 1, // 边框大小
      originX: 'cneter',
      originY: 'cneter',
      left,
      top,
    })
    drawHoles.push(circle)
  })
  // 绘制槽
  let drawSlots = []
  allSlot.forEach((item) => {
    const { opt1: pt1, opt2: pt2 } = item
    let slot = {}
    // 竖拉槽
    if (pt1.x == pt2.x) {
      slot.width = item.width
      slot.x = Math.min(pt1.x, pt2.x) - item.width / 2
      slot.long = Math.abs(pt1.y - pt2.y)
      slot.y = pt1.y > pt2.y ? pt2.y : pt1.y
    }
    // 横拉槽
    if (pt1.y == pt2.y) {
      slot.width = Math.abs(pt1.x - pt2.x)
      slot.y = Math.min(pt1.y, pt2.y) - item.width / 2
      slot.long = item.width
      slot.x = pt1.x > pt2.x ? pt2.x : pt1.x
    }
    // 斜槽
    if (pt1.x != pt2.x && pt1.y != pt2.y && item.symbol === 'CCompSlot') {
      const obliqueSlot = calculateSlantedRectanglePath(pt1, pt2, item.width)
      const path = obliqueSlot.path.map((point) => {
        return {
          x: !(jx_checked && !NC_SETTING.xyReverse)
            ? point.x * slotHoleDefaultScale * CONFIG.scale
            : (rect.width - point.x) * slotHoleDefaultScale * CONFIG.scale,
          y: !(jx_checked && NC_SETTING.xyReverse)
            ? point.y * slotHoleDefaultScale * CONFIG.scale
            : (rect.height - point.y) * slotHoleDefaultScale * CONFIG.scale,
        }
      })
      const poly = new fabric.Polygon(path, {
        fill, //填充的颜色
        stroke, // 边框颜色
        strokeWidth: 1, // 边框大小
      })
      drawSlots.push(poly)
    } else {
      // 与孔一致：jx_checked 且非 xy 互换时镜像 X，jx_checked 且 xy 互换时镜像 Y。
      // fabric.Rect 为左上角定位，镜像须减去槽在板件坐标下的宽高（孔用中心点公式不能直接套左上角）。
      const mirrorX = jx_checked && !NC_SETTING.xyReverse
      const mirrorY = jx_checked && NC_SETTING.xyReverse
      let left = slot.x * slotHoleDefaultScale * CONFIG.scale
      let top = slot.y * slotHoleDefaultScale * CONFIG.scale
      if (mirrorX) {
        left =
          (rect.width - slot.x - slot.width) *
          slotHoleDefaultScale *
          CONFIG.scale
      }
      if (mirrorY) {
        top =
          (rect.height - slot.y - slot.long) *
          slotHoleDefaultScale *
          CONFIG.scale
      }
      const width = slot.width * slotHoleDefaultScale * CONFIG.scale
      const height = slot.long * slotHoleDefaultScale * CONFIG.scale
      const slotRect = new fabric.Rect({
        selectable: false,
        stroke,
        strokeWidth: 1,
        fill,
        width,
        height,
        left,
        top,
      })
      drawSlots.push(slotRect)
    }
  })
  // 绘制异形槽
  const drawCurveSlots = allCurveSlot.map((curve) => {
    const path = curve.path.map((point) => {
      return {
        x: !(jx_checked && !NC_SETTING.xyReverse)
          ? point.x * slotHoleDefaultScale * CONFIG.scale
          : (rect.width - point.x) * slotHoleDefaultScale * CONFIG.scale,
        y: !(jx_checked && NC_SETTING.xyReverse)
          ? point.y * slotHoleDefaultScale * CONFIG.scale
          : (rect.height - point.y) * slotHoleDefaultScale * CONFIG.scale,
      }
    })
    const poly = new fabric.Polygon(path, {
      fill, //填充的颜色
      stroke, // 边框颜色
      strokeWidth: 1, // 边框大小
    })
    return poly
  })
  // 绘制线槽（拉线槽/自定义刀路）
  const drawLineSlots = []
  allLineSlot.forEach((lineSlot) => {
    if (!lineSlot.path) return
    const polygonArr = lineSlot.polygonArr
    if (!polygonArr?.length) return
    polygonArr.forEach((polygon) => {
      const path = polygon.map((point) => {
        return {
          x: !(jx_checked && !NC_SETTING.xyReverse)
            ? point.x * slotHoleDefaultScale * CONFIG.scale
            : (rect.width - point.x) * slotHoleDefaultScale * CONFIG.scale,
          y: !(jx_checked && NC_SETTING.xyReverse)
            ? point.y * slotHoleDefaultScale * CONFIG.scale
            : (rect.height - point.y) * slotHoleDefaultScale * CONFIG.scale,
        }
      })
      // 使用 Polyline 仅描边，行为对齐 ctx.stroke()，避免 Polygon 闭合产生的额外连线与填充覆盖
      const polyline = new fabric.Polyline(path, {
        fill: 'transparent',
        stroke,
        strokeWidth: 1,
        selectable: false,
      })
      drawLineSlots.push(polyline)
    })
  })
  let groupTop = cutTop
  let groupLeft = cutLeft
  const groupWidth = rect.width * slotHoleDefaultScale * CONFIG.scale
  const groupHeight = rect.height * slotHoleDefaultScale * CONFIG.scale
  if (NC_SETTING.xyReverse) {
    groupTop = cutTop + (groupWidth - groupHeight) / 2
    groupLeft = cutLeft - (groupWidth - groupHeight) / 2
  }
  // 绘制四周封边
  const edgeDraws = []
  if (partEdge) {
    const edgeInfo = part.edgeInfo ?? '←0↓0→0↑0'
    const edgeInfoArr = edgeInfo.split(/←|↓|→|↑/).filter((it) => it)
    // 从已保存的other数据中找到设置的字体
    const textInfo = other.tempData.find(
      (item) =>
        item.data &&
        item.data.uniqueID == uniqueID &&
        item.type &&
        item.type.includes('size')
    )

    const fontFamily = textInfo?.data.fontFamily ?? '微软雅黑'
    const fontSize = textInfo?.data.fontSize ?? 13
    edgeInfoArr.forEach((e, i) => {
      const { width: textWidth, height: textHeight } = getTextSize(
        e,
        fontSize * CONFIG.scale,
        fontFamily
      )
      let res = null
      switch (i) {
        case 0:
          res = new fabric.Text(e, {
            fontSize: fontSize * CONFIG.scale,
            left:
              jx_checked && !NC_SETTING.xyReverse
                ? mainShape.width + 2 // 2是为了留出一点间隙
                : 0 - Number(textWidth) - 2, // 2是为了留出一点间隙
            top: mainShape.height / 2 - textHeight,
            fontFamily: fontFamily,
            fill: stroke,
          })
          break
        case 1:
          res = new fabric.Text(e, {
            fontSize: fontSize * CONFIG.scale,
            left: mainShape.width / 2,
            top:
              mainShape.height +
              (auxiliary[0] && auxiliary[0].data.isShow ? textHeight : 0),
            fontFamily: fontFamily,
            fill: stroke,
          })
          break
        case 2:
          res = new fabric.Text(e, {
            fontSize: fontSize * CONFIG.scale,
            left:
              jx_checked && !NC_SETTING.xyReverse
                ? 0 - Number(textWidth) - 2 // 2是为了留出一点间隙
                : mainShape.width + 2, // 2是为了留出一点间隙
            top: mainShape.height / 2 - textHeight,
            fontFamily: fontFamily,
            fill: stroke,
          })
          break
        case 3:
          res = new fabric.Text(e, {
            fontSize: fontSize * CONFIG.scale,
            left: mainShape.width / 2 - Number(textWidth),
            top: 0 - textHeight,
            fontFamily: fontFamily,
            fill: stroke,
          })
          break
        default:
          break
      }
      if (res) {
        if (NC_SETTING.xyReverse || isRotatePlank) res.rotate(90)
        if (NC_SETTING.xyReverse && isRotatePlank) res.rotate(180)
        edgeDraws.push(res)
      }
    })
  }
  mainShape = part.path ? shapes : [mainShape]
  const group = new fabric.Group(
    [
      ...mainShape,
      ...drawHoles,
      ...drawSlots,
      ...textArr,
      ...drawCurveSlots,
      ...drawLineSlots,
      ...edgeDraws,
    ],
    {
      selectable: false,
      left: groupLeft,
      top: groupTop,
      width: groupWidth,
      height: groupHeight,
    }
  )
  // 当xy互换的时候孔槽图逆时针旋转90°
  if (NC_SETTING.xyReverse || isRotatePlank) group.rotate(-90)
  if (NC_SETTING.xyReverse && isRotatePlank) group.rotate(-180)
  canvas.add(group)
}

/**
 * 绘制加工顺序图
 * @param {*} canvas fabric canvas
 * @param {*} part 板件数据
 * @param {*} rectL 矩形左边界
 * @param {*} rectT 矩形上边界
 * @param {*} info 加工顺序图数据
 */
export async function drawSideMachiningSequenceDiagram(
  canvas,
  part,
  rectL,
  rectT,
  info,
  { jx_checked, gen_part_color_revert, tempData }
) {
  const { sholeInfo, sholeInfoF, sslotInfo, sslotInfoF } = part
  const {
    left,
    top,
    scaleX,
    scaleY,
    mWidth,
    mHeight,
    flipOverProcessing,
    showSideMachiningSequenceDiagramBorder,
    showSideMachiningSequenceNumber,
    fontPt,
  } = info

  // 根据侧孔机加工循序获取正确数据，该数据已经包含了侧孔侧槽：
  const targets = getOtherSideMachineTargets(part, false)
  const targetF = getOtherSideMachineTargets(part, true)
  /** 侧孔机加工顺序正面（带孔/槽类型，供示意图区分） */
  const sideHoleMachineProcessing = genCCWSideHoleSlot(
    targets,
    NC_SETTING.xyReverse,
    true
  )
  /** 侧孔机加工顺序反面（带孔/槽类型，供示意图区分） */
  const sideHoleMachineProcessingF = genCCWSideHoleSlot(
    targetF,
    NC_SETTING.xyReverse,
    true
  )
  // 侧孔侧槽绘制信息
  const sholeSslotDrawInfo = flipOverProcessing
    ? sideHoleMachineProcessingF
    : sideHoleMachineProcessing
  if (!sholeSslotDrawInfo) {
    return
  }
  const sholeSslotDrawInfoArr = sholeSslotDrawInfo.match(/\d+[←↓→↑][孔槽]?/g)
  const rectLeft = (left - rectL + 7.5) * CONFIG.scale
  const rectTop = (top - rectT + 7.5) * CONFIG.scale

  // 内框跟模板 mm 走，不拿 Group 整框 width 当内框
  const innerMmW = Number(mWidth) || 20
  const innerMmH = Number(mHeight) || 20
  const codeWidth = Math.round(
    mmToPx(innerMmW, DPI) * (scaleX || 1) * CONFIG.scale
  )
  const codeHeight = Math.round(
    mmToPx(innerMmH, DPI) * (scaleY || 1) * CONFIG.scale
  )
  // 矩形在 Group 中的位置应该是 (0, 0)，Group 子对象用局部坐标
  const sideMachiningSequenceDiagramBaseRect = new fabric.Rect({
    top: 0,
    left: 0,
    width: codeWidth,
    height: codeHeight,
    fill: gen_part_color_revert ? '#000' : 'rgba(0,0,0,0)',
    stroke: gen_part_color_revert ? '#fff' : 'rgba(0,0,0,.2)',
    strokeWidth: 2,
    selectable: false,
    evented: false,
    opacity: showSideMachiningSequenceDiagramBorder ? 1 : 0,
    typeName: 'sideMachiningSequenceDiagramBaseRect',
  })

  // 绘制孔图片
  const loadHoleImage = () => {
    return new Promise((resolve) => {
      fabric.Image.fromURL(require('../../assets/hole.png'), (img) => {
        resolve(img)
      })
    })
  }

  // 绘制侧槽图片
  const loadSideSlotImage = () => {
    return new Promise((resolve) => {
      fabric.Image.fromURL(require('../../assets/slot2.png'), (slotImg) => {
        resolve(slotImg)
      })
    })
  }
  // 包装 clone 方法
  const cloneImage = (sourceImg) => {
    if (!sourceImg || typeof sourceImg.clone !== 'function') {
      return Promise.resolve(null)
    }
    return new Promise((resolve) => {
      sourceImg.clone((clonedImg) => {
        resolve(clonedImg)
      })
    })
  }
  let canvasArr = [sideMachiningSequenceDiagramBaseRect]
  // 所有元素在 async 内构建后统一放入 Group 再 add，需 return Promise 供 createTag 等待
  return (async () => {
    const holeImg = await loadHoleImage()
    // 获取图片原始尺寸
    const imgWidth = holeImg.width || holeImg.getScaledWidth()
    const imgHeight = holeImg.height || holeImg.getScaledHeight()
    // 等比缩放
    const scale = 0.1 * 2
    const scaledWidth = imgWidth * scale
    const scaledHeight = imgHeight * scale
    // 计算图片位置：在矩形上方中心（相对于 Group 的坐标系）
    const holeSpacing = mmToPx(2, DPI)
    const holeTop = -holeSpacing // 图片中心距离矩形顶部 1mm（转换为 px），负值表示在矩形上方
    const holeLeft = -holeSpacing
    const holeRight = codeWidth + holeSpacing + 1
    const holeBottom = codeHeight + holeSpacing + 1
    // 中心图片位置
    const holeCenterLeft = codeWidth / 2 // 矩形中心（相对于 Group）
    const holeCenterTop = codeHeight / 2 // 矩形中心（相对于 Group）
    //  上下 和 左右 分别间隙要更具宽高计算
    const holeSpacingW = (codeWidth - scaledHeight * 5) / 2 // 左右图片距离中心图片 6mm
    const holeSpacingH = (codeHeight - scaledHeight * 5) / 2 // 上下图片距离中心图片 6mm
    let holeGroup1 = null
    if (/[↓↑]/.test(sholeSslotDrawInfo)) {
      // 设置中心图片
      holeImg.set({
        left: holeCenterLeft,
        top: holeTop,
        scaleX: scale,
        scaleY: scale,
        angle: 90,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
        typeName: 'sideMachiningSequenceDiagramHole',
      })
      // 复制两个图片，分别放在左右两侧 模拟侧孔
      const imgLeft = await cloneImage(holeImg)
      imgLeft.set({
        left: holeCenterLeft - holeSpacingW,
        top: holeTop,
        scaleX: scale,
        scaleY: scale,
        angle: 90,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
        typeName: 'sideMachiningSequenceDiagramHole',
      })
      const imgRight = await cloneImage(holeImg)
      imgRight.set({
        left: holeCenterLeft + holeSpacingW,
        top: holeTop,
        scaleX: scale,
        scaleY: scale,
        angle: 90,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
        typeName: 'sideMachiningSequenceDiagramHole',
      })
      // 将三个图片组成一个组（上边的组 宽度间隙）
      holeGroup1 = new fabric.Group([holeImg, imgLeft, imgRight], {
        left: holeCenterLeft,
        top: holeTop,
        selectable: false,
        evented: false,
        originX: 'center',
        originY: 'center',
        typeName: 'sideMachiningSequenceDiagramHoleGroup',
      })
    }
    let holeGroup2 = null
    if (/[←→]/.test(sholeSslotDrawInfo)) {
      const holeImg2 = await cloneImage(holeImg)
      holeImg2.set({
        left: holeCenterTop,
        top: holeTop,
        scaleX: scale,
        scaleY: scale,
        angle: 90,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
        typeName: 'sideMachiningSequenceDiagramHole',
      })
      // 复制两个图片，分别放在左右两侧 模拟侧孔
      const imgLeft2 = await cloneImage(holeImg2)
      imgLeft2.set({
        left: holeCenterTop - holeSpacingH,
        top: holeTop,
        scaleX: scale,
        scaleY: scale,
        angle: 90,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
        typeName: 'sideMachiningSequenceDiagramHole',
      })
      const imgRight2 = await cloneImage(holeImg2)
      imgRight2.set({
        left: holeCenterTop + holeSpacingH,
        top: holeTop,
        scaleX: scale,
        scaleY: scale,
        angle: 90,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
        typeName: 'sideMachiningSequenceDiagramHole',
      })
      // 将三个图片组成一个组（上边的组 宽度间隙）
      holeGroup2 = new fabric.Group([holeImg2, imgLeft2, imgRight2], {
        left: holeCenterLeft,
        top: holeTop,
        selectable: false,
        evented: false,
        originX: 'center',
        originY: 'center',
        typeName: 'sideMachiningSequenceDiagramHoleGroup',
      })
    }
    // 绘制侧槽
    const slotImg = await loadSideSlotImage()
    const slotImgWidth = slotImg.width || slotImg.getScaledWidth()
    const slotImgHeight = slotImg.height || slotImg.getScaledHeight()
    const slotImgScale = 0.34 * 2
    const slotImgScaledWidth = slotImgWidth * slotImgScale
    const slotImgScaledHeight = slotImgHeight * slotImgScale
    // 为了保持侧槽和其相邻边也一样长，需要计算缩放比例
    const a = codeWidth / slotImgScaledWidth
    const b = codeHeight / slotImgScaledWidth
    slotImg.set({
      left: 0,
      top: 0,
      scaleX: slotImgScale,
      scaleY: slotImgScale,
      selectable: false,
      evented: false,
      typeName: 'sideMachiningSequenceDiagramSlot',
    })
    let slotImg1 = null
    if (/[↓↑]/.test(sholeSslotDrawInfo)) {
      slotImg1 = await cloneImage(slotImg)
      slotImg1.set({
        scaleX: slotImgScale * a,
        scaleY: slotImgScale,
        left: 0,
        top: 0 - slotImgScaledHeight - 1,
        angle: 0,
      })
    }
    let slotImg2 = null
    if (/[←→]/.test(sholeSslotDrawInfo)) {
      slotImg2 = await cloneImage(slotImg)
      slotImg2.set({
        left: 0,
        top: 0,
        angle: 0,
        scaleX: slotImgScale * b,
        scaleY: slotImgScale,
      })
    }
    // 创建四个数字文本，分别放在四边中间位置（从左边开始逆时针：1、2、3、4）
    // fontPt 为 pt；fabric fontSize 为 px，出标画布再乘 CONFIG.scale
    const numberFontPt = Number(fontPt) || 8
    const textFontSize = PtToPx(numberFontPt, DPI) * CONFIG.scale
    const slotOutset = slotImgScaledHeight + 1
    const holeWidth = scaledHeight

    // 创建四个L型角标，分别放在矩形的四角
    // number=1 时按箭头画起始角：←左下 ↓右下 →右上 ↑左上
    const cornerMarkLength = mmToPx(4, DPI) // 角标长度 2mm
    const cornerStrokeWidth = 4
    const cornerColor = gen_part_color_revert ? '#fff' : 'rgba(0,0,0,.8)'
    const cornerPolygonOpts = {
      fill: cornerColor,
      stroke: cornerColor,
      strokeWidth: 0,
      selectable: false,
      evented: false,
      typeName: 'sideMachiningSequenceDiagramCorner',
    }
    // number=1 时按箭头画起始角：直角对应原 L 形角点
    // ←左下 ↓右下 →右上 ↑左上
    const arrowToCornerCoordsMap = {
      '←': [
        { x: 0, y: codeHeight },
        { x: cornerMarkLength, y: codeHeight },
        { x: 0, y: codeHeight - cornerMarkLength },
      ],
      '↓': [
        { x: codeWidth, y: codeHeight },
        { x: codeWidth - cornerMarkLength, y: codeHeight },
        { x: codeWidth, y: codeHeight - cornerMarkLength },
      ],
      '→': [
        { x: codeWidth, y: 0 },
        { x: codeWidth - cornerMarkLength, y: 0 },
        { x: codeWidth, y: cornerMarkLength },
      ],
      '↑': [
        { x: 0, y: 0 },
        { x: cornerMarkLength, y: 0 },
        { x: 0, y: cornerMarkLength },
      ],
    }
    // 四边孔/槽图与序号：水平边用 holeGroup1/slotImg1，竖直边用 holeGroup2/slotImg2
    const numberTextBaseOpts = {
      opacity: showSideMachiningSequenceNumber ? 1 : 0,
      fill: gen_part_color_revert ? '#fff' : '#000',
      fontSize: textFontSize,
      originX: 'center',
      originY: 'center',
      selectable: false,
      evented: false,
      typeName: 'sideMachiningSequenceDiagramNumber',
    }
    const holeCenterOpts = {
      originX: 'center',
      originY: 'center',
    }
    const arrowToSideDrawMap = {
      '←': {
        slotSrc: () => slotImg2,
        slotSet: { left: -1 * CONFIG.scale, top: 0, angle: 90 },
        holeSrc: () => holeGroup2,
        holeSet: {
          left: holeLeft,
          top: holeCenterTop,
          angle: 90,
          ...holeCenterOpts,
        },
        textSet: {
          left: -slotOutset,
          top: codeHeight / 2 - holeWidth * 2,
          originX: 'right',
          originY: 'center',
        },
      },
      '↓': {
        slotSrc: () => slotImg1,
        slotSet: { left: 0, top: codeHeight + 1 + 1 + 1, angle: 0 },
        holeSrc: () => holeGroup1,
        holeSet: {
          left: holeCenterLeft,
          top: codeHeight + holeSpacing + 1,
          angle: 0,
          ...holeCenterOpts,
        },
        textSet: {
          left: codeWidth / 2 - holeWidth,
          top: codeHeight + slotOutset,
          originX: 'center',
          originY: 'top',
        },
      },
      '→': {
        slotSrc: () => slotImg2,
        slotSet: {
          left: codeWidth + 1 + slotImgScaledHeight + 1 + 1,
          top: 0,
          angle: 90,
        },
        holeSrc: () => holeGroup2,
        holeSet: {
          left: codeWidth + holeSpacing + 1 + 1,
          top: holeCenterTop,
          angle: 90,
          ...holeCenterOpts,
        },
        textSet: {
          left: codeWidth + slotOutset,
          top: codeHeight / 2 - holeWidth * 2,
          originX: 'left',
          originY: 'center',
        },
      },
      '↑': {
        slotSrc: () => slotImg1,
        slotSet: {
          scaleX: slotImgScale * a,
          scaleY: slotImgScale,
          left: 0,
          top: 0 - slotImgScaledHeight - 1,
          angle: 0,
        },
        holeSrc: () => holeGroup1,
        holeSet: {
          left: holeCenterLeft,
          top: holeTop,
          angle: 0,
          ...holeCenterOpts,
        },
        textSet: {
          left: codeWidth / 2 - holeWidth,
          top: -slotOutset,
          originX: 'center',
          originY: 'bottom',
        },
      },
    }

    const numberTexts = []
    for (const it of sholeSslotDrawInfoArr) {
      const match = it.match(/(\d+)([←↓→↑])([孔槽]?)/)
      const number = match ? match[1] : ''
      const arrow = match ? match[2] : ''
      const hsLabel = match ? match[3] : ''
      if (number === '1') {
        const cornerPoints = arrowToCornerCoordsMap[arrow]
        if (cornerPoints) {
          canvasArr.push(
            new fabric.Polygon(cornerPoints, { ...cornerPolygonOpts })
          )
        }
      }

      const sideDraw = arrowToSideDrawMap[arrow]
      if (!sideDraw) {
        continue
      }
      // 优先用顺序串中的孔/槽标记
      const isSlotSide = hsLabel === '槽'
      if (isSlotSide) {
        const slotImgClone = await cloneImage(sideDraw.slotSrc())
        if (slotImgClone) {
          slotImgClone.set(sideDraw.slotSet)
          canvasArr.push(slotImgClone)
        }
      } else {
        const holeGroupClone = await cloneImage(sideDraw.holeSrc())
        if (holeGroupClone) {
          holeGroupClone.set(sideDraw.holeSet)
          canvasArr.push(holeGroupClone)
        }
      }
      numberTexts.push(
        new fabric.Text(number, {
          ...numberTextBaseOpts,
          ...sideDraw.textSet,
          left: rectLeft + (sideDraw.textSet.left || 0),
          top: rectTop + (sideDraw.textSet.top || 0),
        })
      )
    }
    // 创建最终的 Group，数字不进 Group，避免缓存裁切
    const sideMachiningSequenceDiagram = new fabric.Group([...canvasArr], {
      left: rectLeft,
      top: rectTop,
      selectable: true,
      hasControls: true,
      typeName: 'sideMachiningSequenceDiagram',
      originX: 'left',
      originY: 'top',
    })

    // 计算所有元素的边界，包括矩形外部的元素
    // 获取孔图片组的实际尺寸（考虑缩放后的尺寸）
    const holeGroupHalfWidth = (scaledWidth / 2) * 1.5
    const holeGroupHalfHeight = scaledHeight / 2
    const cornerHalfStroke = cornerStrokeWidth / 2

    const minLeft = Math.min(
      holeLeft - holeGroupHalfWidth,
      -slotOutset,
      -cornerHalfStroke
    )
    const minTop = Math.min(
      holeTop - holeGroupHalfHeight,
      -slotOutset,
      -cornerHalfStroke
    )
    const maxRight = Math.max(
      holeRight + holeGroupHalfWidth,
      codeWidth + slotOutset,
      codeWidth + cornerMarkLength + cornerHalfStroke
    )
    const maxBottom = Math.max(
      holeBottom + holeGroupHalfHeight,
      codeHeight + slotOutset,
      codeHeight + cornerMarkLength + cornerHalfStroke
    )

    // 计算 Group 需要的实际宽度和高度（包含所有外部元素）
    const actualWidth = Math.round(maxRight - minLeft)
    const actualHeight = Math.round(maxBottom - minTop)

    // 调整 Group 的位置和尺寸，使其包含所有元素
    // 由于元素都是相对于 (0, 0) 定位的，我们需要调整 Group 的 left 和 top
    sideMachiningSequenceDiagram.set({
      left: Math.round(rectLeft + minLeft),
      top: Math.round(rectTop + minTop),
      width: actualWidth,
      height: actualHeight,
    })
    sideMachiningSequenceDiagram.setCoords()
    canvas.add(sideMachiningSequenceDiagram)
    numberTexts.forEach((text) => {
      canvas.add(text)
    })
    canvas.renderAll()
  })()
}
/**
 * @description 获取当前标签可以需要显示的字体
 */
export function getTagFontFamily(font) {
  // return store.state.exportLanguage === 'ug' ? '维语' : font ?? '微软雅黑'
  switch (store.state.exportLanguage) {
    case 'ug':
      return '维语'
    case 'th':
      return '泰语'
    case 'ben':
      return '孟加拉语'
    case 'kor':
      return '韩语'
    case 'bur':
      return '缅甸语'
    case 'km':
      return '柬埔寨语'
    case 'ar':
      return '维语'
    default:
      return font ?? '微软雅黑'
  }
}

export function drawTagText(canvas, text, info, other, isDraw = true) {
  const { tagOpacity = true } = other
  let Text = new fabric.Textbox(text, {
    fontSize: info.fontSize * (CONFIG.scale ?? 2),
    selectable: false,
    fontWeight: info.fontWeight,
    lineHeight: info.lineHeight,
    left: info.left,
    top: info.top,
    splitByGrapheme: info.splitByGrapheme ? info.splitByGrapheme : false, // 自动换行
    textAlign: info.textAlign ? info.textAlign : 'left',
    scaleX: info.scaleX ?? 1,
    scaleY: info.scaleY ?? 1,
    fontFamily: getTagFontFamily(info.fontFamily),
    opacity: tagOpacity ? info.opacity ?? 1 : 1,
    fill: other?.color ?? '#000',
  })
  if (info.width && info.height)
    Text.set({
      width: info.width * (CONFIG.scale ?? 1),
      height: info.height * (CONFIG.scale ?? 1),
    })
  if (isDraw) {
    canvas.add(Text)
  } else {
    return Text
  }
}

export function getCutDirEdge(dir, textArr, xyReverse) {
  let position = ''
  switch (dir) {
    case '左':
      position = xyReverse ? 'BE' : 'LE'
      break
    case '下':
      position = xyReverse ? 'LE' : 'BE'
      break
    case '右':
      position = xyReverse ? 'TE' : 'RE'
      break
    case '上':
      position = xyReverse ? 'RE' : 'TE'
      break
  }
  return textArr.find((it) => it.position == position)
}

// 绘制开门方向
export function drawOpenDoor(textArr, part, info, nc_setting, type, other) {
  // 控制开门方向在左边的时候 板件图的偏移
  let distance = 0
  let findText = null
  const { xyReverse } = nc_setting
  if (part.doorOpenSide && info.showOpenDoor && type !== 'plank') {
    const doorOpenSide = part.doorOpenSide
    const position = OPENMAPTEXT[doorOpenSide]
    findText = getCutDirEdge(position, textArr)
    let { left, top, width, height } = findText
    // width = width < 20 ? 20 : width
    left = left + width + 10
    top = top + height / 2
    const circle = drawCircle(10, 10, {
      left,
      top,
      canRotate: true,
      openDoor: true,
      ...other,
    })
    const text = drawText('开', top, left, 10, 14, {
      canRotate: true,
      openDoor: true,
      ...other,
    })
    return {
      arr: [circle, text],
      distance,
      findText,
    }
  }
  return {
    arr: [],
    distance,
    findText,
  }
}
// 绘制见光边
export function drawLightSign(textArr, part, nc_setting, type, other) {
  const { lightEdgeInfo } = part
  if (!lightEdgeInfo) return []
  const { xyReverse } = nc_setting
  let result = []
  if (type !== 'plank') {
    const dir = ['左', '下', '右', '上']
    const disposeDirArr = lightEdgeInfo
      .split(/←|↓|→|↑/)
      .filter((it) => it)
      .map((it, idx) => {
        return { value: it, dir: dir[idx] }
      })
    disposeDirArr.forEach((it) => {
      const { value, dir } = it
      if (+value) {
        const findText = getCutDirEdge(dir, textArr)
        let { left, top, width, height, position } = findText
        width = width < 20 ? 20 : width

        const isSide = position == 'LE' || position == 'RE'
        if (isSide) {
          // 绘制在文字下方
          top += height
          if (position == 'RE') {
            left += width / 2
          } else {
            left -= TRIANGLE_WIDTH + 3
          }
        } else {
          left -= TRIANGLE_WIDTH
          top += TRIANGLE_HEIGHT
        }
        const triangle = new fabric.Triangle({
          top,
          left,
          width: 10,
          height: 7,
          fill: !other?.gen_part_color_revert ? '#000' : '#fff',
        })
        // 在各个方向上箭头都对外
        switch (dir) {
          case '左':
            triangle.rotate(-90)
            break
          case '下':
            triangle.rotate(-180)
            break
          case '右':
            triangle.rotate(90)
            break
          case '上':
            triangle.rotate(0)
        }
        result.push(triangle)
      }
    })
  }
  return result
}
//绘制前封边
export function drawFormerEdge(
  textArr,
  part,
  nc_setting,
  type,
  // textMark,
  configScale,
  jxChecked,
  trimSide,
  other
) {
  if (part.model_front_edge && type !== 'plank') {
    const former = part.model_front_edge
    const { xyReverse, startPosition } = nc_setting
    const dir = dirDataMap[former]
    // textArr是拿到的文字的位置
    const findText = getCutDirEdge(dir, textArr)
    let { left, top, width, height } = findText
    if (former == '↓') {
      // 文字的位置加上文字的高度
      top += height
    } else {
      top -= height
    }
    left += width / 2 - 12 / 2

    // 前字 宽12 高13.59
    const text = new fabric.Text(translateTemplateWay('前'), {
      left,
      top,
      // 字体大小跟随设置变化，不固定，默认模板还是12px
      fontSize: store.state.frontLabelFont?.fontSize * configScale ?? 12,
      canRotate: true,
      fontFamily: getTagFontFamily(store.state.frontLabelFont?.fontFamily),
      fontWeight: store.state.frontLabelFont?.fontWeight ?? '',
      fill: !other?.gen_part_color_revert ? '#000' : '#fff',
    })
    return text
  }
}
export function drawCircle(radius, mRadius, other = {}) {
  return new fabric.Circle({
    radius: radius, //圆形半径
    fill: !other.gen_part_color_revert ? '#fff' : '#000', //填充的颜色
    stroke: !other.gen_part_color_revert ? '#000' : '#fff', // 边框颜色
    strokeWidth: 1, // 边框大小
    mRadius,
    originX: 'cneter',
    originY: 'cneter',
    left: radius,
    top: radius,
    ...other,
  })
}
export function drawText(text, top, left, pt, fontSize, other = {}) {
  return new fabric.IText(text + '', {
    fontSize: pt,
    fontPt: fontSize,
    fontWeight: '',
    originX: 'cneter',
    originY: 'cneter',
    left: left,
    top: top,
    ...other,
    fill: !other.gen_part_color_revert ? '#000' : '#fff',
  })
}

export function handleOpenDoorDistance(klass, info, findText) {
  const openKlass = klass.getObjects().filter((it) => it.openDoor)
  if (!openKlass.length) return
  if (findText && findText.position == 'LE') {
    openKlass.forEach((it) => {
      if (info.plankRotate) {
        it.left = it.left - findText.height - 20
      } else {
        it.left = it.left - findText.width - 20
      }
    })
  }
}

// fabric绘制表格
export function fabricTable(
  canvas,
  isEdit = false,
  tableData,
  fontSize = 16,
  type = 'extraParts',
  top = 10,
  left = 10,
  fontFamily = '微软雅黑',
  other
) {
  const tableTypeObj = {
    extraParts: [['名称', '规格', '数量']],
  }
  const defaultTable = {
    extraParts: [
      ['名称', '规格', '数量'],
      ['款式1', '巨型', '1'],
      ['款式2', '小型', '1'],
    ],
  }
  const d = defaultTable[type]
  let data = tableTypeObj[type]
  if (tableData && tableData.length) {
    data = data.concat(tableData)
  }
  if (isEdit && !tableData) {
    data = d
  }
  let columsText = []
  for (let index = 0; index < data[0].length; index++) {
    columsText.push(data.map((e) => e[index]))
  }
  const columsWidth = columsText.map((e) => {
    const widthArr = e.map((text) => calcTextSize(text, fontSize).width + 15)
    return Math.max(...widthArr)
  })
  const rowHeight = calcTextSize(data[0][0], fontSize).height
  // 表格宽度
  let totalWidth = 0
  columsWidth.forEach((width) => {
    totalWidth += width
  })
  // 表格高度
  let totalHeight = data.length * rowHeight

  let myCanvas = new fabric.StaticCanvas(`myCanvas`, {
    width: totalWidth + 5,
    height: totalHeight + 5,
  })
  let stroke = !other?.gen_part_color_revert ? '#000' : '#fff'

  for (let i = 0; i < data.length; i++) {
    let leftWidth = isEdit ? 0 : left
    let topHeight = isEdit ? 0 : top
    topHeight += rowHeight * i
    for (let j = 0; j < data[0].length; j++) {
      if (j) {
        leftWidth += columsWidth[j - 1]
      }
      // 创建表格元素
      let cell = new fabric.Rect({
        left: leftWidth,
        top: topHeight,
        fill: !other?.gen_part_color_revert ? '#fff' : '#000',
        width: columsWidth[j],
        height: rowHeight,
        stroke,
        strokeWidth: 1,
      })
      let text = new fabric.Text(data[i][j], {
        left:
          leftWidth +
          (columsWidth[j] - calcTextSize(data[i][j], fontSize).width) / 2,
        top: topHeight + 3,
        fontSize: fontSize,
        fontFamily,
        fill: stroke,
      })

      isEdit ? myCanvas.add(cell) : canvas.add(cell)
      isEdit ? myCanvas.add(text) : canvas.add(text)
    }
  }

  let startX = isEdit ? 0 : left
  let startY = isEdit ? 0 : top
  totalWidth = isEdit ? totalWidth : totalWidth + left
  totalHeight = isEdit ? totalHeight : totalHeight + top

  // 表格border
  const border1 = new fabric.Line([startX, startY, totalWidth, startY], {
    stroke,
    strokeWidth: 1,
  })
  const border2 = new fabric.Line(
    [totalWidth, startY, totalWidth, totalHeight],
    {
      stroke,
      strokeWidth: 1,
    }
  )
  const border3 = new fabric.Line(
    [startX, totalHeight, totalWidth, totalHeight],
    {
      stroke,
      strokeWidth: 1,
    }
  )
  const border4 = new fabric.Line([startX, startY, startX, totalHeight], {
    stroke,
    strokeWidth: 1,
  })

  // 画布上画出border

  if (isEdit) {
    myCanvas.add(border1, border2, border3, border4)
    const imgBase64 = myCanvas.toDataURL('image/png', {
      quality: 1,
      format: 'jpeg',
    })
    return imgBase64
  } else {
    canvas.add(border1, border2, border3, border4)
  }
}

// 计算文字宽度
export function calcTextSize(text, fontSize = 14) {
  let span = document.createElement('span')
  let result = {}
  result.width = span.offsetWidth
  result.height = span.offsetHeight
  span.style.visibility = 'hidden'
  span.style.fontSize = `${fontSize}px`
  span.style.fontFamily = 'PingFangSC-Regular, PingFang SC'
  span.style.display = 'inline-block'
  document.body.appendChild(span)
  if (typeof span.textContent != 'undefined') {
    span.textContent = text
  } else {
    span.innerText = text
  }
  result.width = parseFloat(window.getComputedStyle(span).width) - result.width
  result.height =
    parseFloat(window.getComputedStyle(span).height) - result.height
  document.body.removeChild(span)
  return {
    width: result.width,
    height: result.height,
  }
}

// 标签特殊标记形状
export const signShape = {
  triangle_shape: [
    { x: 0, y: 50 },
    { x: 25, y: 0 },
    { x: 50, y: 50 },
  ],
  square_shape: [
    { x: 0, y: 0 },
    { x: 50, y: 0 },
    { x: 50, y: 50 },
    { x: 0, y: 50 },
  ],
  // hexagon_shape: new Array(6).fill(null).map((_, index) => {
  //   const radius = 25
  //   const angle = (index * Math.PI) / 3
  //   return index
  //     ? { x: radius * Math.cos(angle), y: radius * Math.sin(angle) }
  //     : { x: radius, y: 0 }
  // }),
  hexagon_shape: [
    { x: 0, y: 18.75 },
    { x: 12.5, y: 0 },
    { x: 37.5, y: 0 },
    { x: 50, y: 18.75 },
    { x: 37.5, y: 37.5 },
    { x: 12.5, y: 37.5 },
  ],
}
export function drawSpecialSign(
  ctx,
  sign,
  template,
  opacity = 0.24,
  sizeAuto = true,
  size = 1,
  other = {},
  op
) {
  if (!sign || sign === 'default' || template.type === 'plank') return

  const cusSpecialFlag = op && Reflect.ownKeys(op).length > 0
  const { left, top, custSpeciialTagratioX, custSpeciialTagratioY } = op ?? {}
  if (sizeAuto) {
    size = 1
  }
  const widthBase = ctx.getWidth()
  const heightBase = ctx.getHeight()
  const center = cusSpecialFlag
    ? { x: left, y: top }
    : { x: widthBase / 2, y: heightBase / 2 }
  const diameter = 75
  const ratio = Math.min(widthBase / diameter, heightBase / diameter) * size //返回低值数字
  const scale = 0.92
  let stroke = !other?.gen_part_color_revert ? '#000' : '#fff'
  let fill = !other?.gen_part_color_revert ? 'transparent' : '#000'
  switch (sign) {
    case 'triangle_shape':
    case 'square_shape':
    case 'hexagon_shape':
      drawPathShape(sign)
      break
    case 'circle_shape':
      drawCircleShape()
      break
    case 'half_circle_shape':
      drawHalfCircle()
      break
  }
  // 路径可以绘制的形状 三角形/矩形/六边形
  function drawPathShape() {
    const path = signShape[sign].map((it) => ({
      x: it.x * (custSpeciialTagratioX ?? ratio),
      y: it.y * (custSpeciialTagratioY ?? ratio),
    }))
    const polygon = new fabric.Polygon(path, {
      fill: !other?.gen_part_color_revert ? 'transparent' : '#000',
      stroke,
      strokeWidth: 2,
      opacity,
    })
    const littlePolygon = new fabric.Polygon(
      path.map((it) => ({
        x: it.x * scale,
        y: it.y * scale,
      })),
      {
        fill: stroke,
        opacity,
      }
    )
    dealCenter(polygon, littlePolygon)
    if (sign === 'triangle_shape') {
      littlePolygon.set({ top: littlePolygon.top + littlePolygon.height / 50 }) //魔法数字(麻了)
    }
    ctx.add(polygon, littlePolygon)
  }
  // 圆形特殊标记(2024-08-02 周驰修改 修改原因：圆也是椭圆)
  function drawCircleShape() {
    const option = {
      // radius: 25 * ratio,
      rx: 25 * (custSpeciialTagratioX ?? ratio),
      ry: 25 * (custSpeciialTagratioY ?? ratio),
      opacity,
      top: center.y,
      left: center.x,
      originX: 'center',
      originY: 'center',
    }
    const circle = new fabric.Ellipse({
      ...option,
      fill,
      stroke,
      strokeWidth: 2,
    })
    const littleCircle = new fabric.Ellipse({
      ...option,
      // radius: 25 * ratio * scale,
      rx: 25 * (custSpeciialTagratioX ?? ratio) * scale,
      ry: 25 * (custSpeciialTagratioY ?? ratio) * scale,
      fill: stroke,
    })
    ctx.add(circle, littleCircle)
  }
  // 半圆特殊标记
  function drawHalfCircle() {
    // 自定义特殊标签的半径和缩放都用值小的
    const othRadio = cusSpecialFlag
      ? Math.min(custSpeciialTagratioX, custSpeciialTagratioY)
      : ratio
    const radius = 25 * othRadio
    const littleRadius = radius * scale
    const halfCircle = new fabric.Path(
      `M 0,${radius} A ${radius},${radius} 0 0,1 ${
        radius * 2
      },${radius} L ${radius},${radius} L 0,${radius} Z`,
      {
        fill, // 填充颜色为白色
        stroke, // 描边颜色为黑色
        strokeWidth: 2, // 描边宽度为2
        opacity,
      }
    )
    const littleHalfCircle = new fabric.Path(
      `M 0,${littleRadius} A ${littleRadius},${littleRadius} 0 0,1 ${
        littleRadius * 2
      },${littleRadius} L ${littleRadius},${littleRadius} L 0,${littleRadius} Z`,
      { opacity, fill: stroke }
    )
    dealCenter(halfCircle, littleHalfCircle)
    ctx.add(halfCircle, littleHalfCircle)
  }
  // 居中
  function dealCenter(...klass) {
    klass.forEach((it) => {
      it.set({
        left: center.x - it.width / 2,
        top: center.y - it.height / 2,
      })
    })
  }
}

// 处理文字换行
let reFontSize = ''
export function dealTextStr(
  str,
  fontSize,
  maxWidth,
  maxHeight,
  isAutoFontSize = false,
  lineCount = ''
) {
  reFontSize = fontSize
  const { height: h } = new fabric.Text('A', { fontSize })
  const strArr = str.trim()?.split('\n')

  const res = strArr.map((str) => {
    let lineWidth = 0 //行宽度 满了就置0
    let res = ''
    let count = 0
    for (const s of str) {
      const { width: w } = new fabric.Text(String(s), { fontSize })
      if (lineCount) {
        if (count < lineCount) {
          count++
          res = res + String(s)
        } else {
          res = res + '\n' + String(s)
          count = 1
        }
      } else {
        if (lineWidth + w > maxWidth) {
          res = res + '\n' + String(s)
          lineWidth = 0
        } else {
          lineWidth += w
          res = res + String(s)
        }
      }
    }
    return res
  })

  let textH = 0
  if (lineCount) {
    textH = res.length * h
  } else {
    textH = res.join('\n').split('\n').length * h
  }
  if (textH > maxHeight && isAutoFontSize) {
    return dealTextStr(str, fontSize - 1, maxWidth, maxHeight, isAutoFontSize)
  } else {
    return {
      text: res.join('\n'),
      oriText: str,
      fontSize: reFontSize,
      isLineBreak: res.length > 1,
    }
  }
}

export function getTextSize(str, fontSize, fontFamily) {
  const text = new fabric.Text(str ?? '', {
    fontSize: fontSize ?? 16,
    fontFamily: fontFamily ?? 'Arial',
  })

  return {
    width: text.width,
    height: text.height,
  }
}

/**
 * @description 根据用户设置的分辨率重新生成一张图片/如果用户未设置分辨率则返回原图片
 * @param {string} imgBase64 图片base64
 * @param {object} ncSetting nc设置
 * @returns {string} 重新生成的图片base64
 */
export async function getTagImageByResolution(imgBase64, ncSetting) {
  try {
    const [width, height] = ncSetting.label_resolution ?? []
    if (!width || !height) return imgBase64
    const el = document.createElement('canvas')
    el.width = width
    el.height = height
    const ctx = el.getContext('2d')
    // 关闭插值，避免条码/二维码缩放时黑条发糊变粗
    ctx.imageSmoothingEnabled = false
    const img = new Image()
    img.src = imgBase64
    return await new Promise((resolve) => {
      img.onload = () => {
        ctx.drawImage(img, 0, 0, width, height)
        resolve(el.toDataURL(ncSetting.labelImageFormatNew, 1))
      }
    })
  } catch (error) {
    console.log(error)
    return imgBase64
  }
}
